module.exports = "img/grupo.a6c469.jpeg";